module.exports = __webpack_public_path__ + "static/media/skyline.e47034d3.svg";